// Side-effect: register all content modules
import "./modules";

export type {
  ContentBlock,
  ContentBlockId,
  ContentBlockKind,
  ContentTag,
  ContentBody,
  InfoBody,
  ChecklistBody,
  DataPointBody,
  DataPointSampleType,
  TestBody,
  TipBody,
  FaqBody,
  CostItemBody,
  SupplementBody,
  TimelineStepBody,
  EvidenceBody,
  GuideBody,
  ComparisonBody,
  CalloutBody,
  ProductBody,
  ArticleBody,
  ProgramBody,
  TherapyBody,
  ProcedureBody,
  ProcedureCategory,
  ModuleBody,
  MedicationBody,
  MedicationRoute,
  MedicationForm,
  MedicationResource,
  ConditionBody,
  ConditionCategory,
  TestMarkerCategory,
  ProgramCategory,
  TrackableMarker,
  PersonalizationCondition,
  EvidenceSource,
  EvidenceLevel,
  Interaction,
} from "./types";

export type { ContentRelationship, RelationshipType } from "./relationships";

export {
  resolveMedicationMarketCountry,
  resolveMedicationResources,
  type MedicationMarketContext,
} from "./medicationResources";

export type {
  OnboardingProfile,
  JourneyPhase,
  AgeRange,
  Condition,
  Timeline,
  PartnerChoice,
} from "./profile-types";

export {
  registerBlock,
  registerLocaleVariant,
  registerRelationship,
  setActiveContentLocale,
  getBlock,
  getBlockOrThrow,
  getBlocksByTag,
  getBlocksByKind,
  getRelatedBlocks,
  getChildBlocks,
  getAllBlocks,
  getAllRelationships,
  getAllTags,
  getAllKinds,
  getModulesForProgram,
  getProgramsContainingModule,
} from "./registry";

export {
  makeId,
  getMedicationByBrandName,
  getSupplementByName,
  getConditionByName,
  getProcedureByName,
  getTestByName,
} from "./helpers";

export {
  getDataPointForMarkerName,
  getDataPointsForTest,
  getDataPointsForProduct,
  getCollectionLabel,
  getSampleTypeLabel,
  getTestingMethodsForMarker,
  getTestsForDataPoint,
} from "./biomarkers";
export type { BiomarkerTestingMethod } from "./biomarkers";

export { isBlockRelevant, filterBlocks } from "./personalization";

export { searchContent } from "./search";
export type { SearchResult } from "./search";

export { SupplementRow } from "./components/SupplementRow";
export type { SupplementEvidence } from "./components/SupplementRow";
export { InteractionsList } from "./components/InteractionsList";
